/** @module csi/table/ToolbarColumns */
define([
	"csi/def/ActionFactory",
	"csi/view/Attributes"
], function(ActionFactory, Attributes) {

	return ActionFactory.declare("columns", Attributes, {
		m_id: "ViewColumns",
		m_class: "iconTableColumns",

		classToolbarPluginParams: {
			allowResetColumnWidths: true,

			onResetColumnWidths: function() {
				this.getView().resetFixedColumnWidths();
			},
		},

		/**
		 * Table icon uses SVG
		 */
		constructor: function() {
			this.setMaterialIcon(null);
		}
	});
});